var map = {
	"./class-attendance-report/route.js": "fdc2",
	"./class-attendance-report/store.js": "a02d",
	"./class-attendance-v2/route.js": "7cd9",
	"./class-attendance-v2/store.js": "de2c",
	"./fee-predefine-item/route.js": "ba4e",
	"./fee-predefine-item/store.js": "39b9",
	"./store.js": "2079",
	"./student-transfer-module/components/index.js": "3d32",
	"./student-transfer-module/store.js": "d983"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4da3";